// extracted by mini-css-extract-plugin
export var orderSummary = "_to-0";
export var showMoreLessButton = "_to-1";